import moment from 'moment';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { APP_CONFIG } from '@app/modules/core/config/config';
import * as AppActions from '@app/store/actions/app.actions';
import { IAppConfig } from '@app/store/models/config.interface';
import { CoreSeoPages } from '@app/store/enums/core-seo-pages';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { PublicUserDetails, SystemUserTypes } from 'shared-library';
import { selectAppState } from '@app/store/selectors/app.selectors';
import { SeoService } from '@app/modules/core/services/seo.service';
import { CoreService } from '@app/modules/core/services/core.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { PaymentService } from '@app/modules/core/services/payment.service';
import { FunctionsService } from '@app/modules/core/services/functions.service';
import { PromotionalDiscounts } from '@app/store/models/promotional-discounts.interface';
import { PublicInformationPageMessageTypes } from '@app/modules/shared/components/public-information-page/public-information-page.enum';
declare const bootstrap: any

@Component({
  selector: 'app-core-promotional-discounts',
  templateUrl: './core-promotional-discounts.component.html',
  styleUrls: ['./core-promotional-discounts.component.scss']
})
export class CorePromotionalDiscountsComponent implements OnInit {

  message_mode = PublicInformationPageMessageTypes.DISCOUNT

  appState$ = this.store.select(selectAppState);
  promo_code: PromotionalDiscounts
  promo_codes: Array<PromotionalDiscounts>;

  session_info: SessionInfo
  private subscriptions: Subscription[] = []
  @Input() user_details: PublicUserDetails = null;

  modal_element: any

  constructor(
    private store: Store,
    private seoService: SeoService,
    public coreService: CoreService,
    public functionService: FunctionsService,
    public readonly paymentService: PaymentService,
    @Inject(APP_CONFIG) private readonly config: IAppConfig
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))

    this.subscriptions.push(
      this.appState$.subscribe(ls => this.sortPromoCodes(ls.data.cache.promo_codes))
    )
  }

  ngOnInit() {
    if (this.coreService.isLoggedIn()) {
      if (!this.user_details) this.user_details = JSON.parse(JSON.stringify(this.session_info.user_details))
    }
    this.getPricings()
    this.seoService.generateMetaTags(CoreSeoPages.PROMOTIONS)
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }

  openModal(id: string) {
    this.modal_element = new bootstrap.Modal(document.getElementById(id), {
      keyboard: false
    })
    this.modal_element.show()
  }

  private async getPricings() {
    let url = this.config.apiEndpoints.resources.pricings
    if (this.coreService.isLoggedIn()) {
      url = this.session_info.user_details.user_category === SystemUserTypes.ADMIN ? this.config.apiEndpoints.user.pricings.replace("/{id}", `/${this.user_details.id}`) : this.config.apiEndpoints.user.pricings.replace("/{id}", ``)
      url = `${url}plan_subscription`
    }
    this.store.dispatch(AppActions.fetchSubscriptionPrices({ url, force: true }))
  }

  private sortPromoCodes(promo_codes: PromotionalDiscounts[]) {
    if (!promo_codes?.length) {
      this.promo_codes = []
      return
    }
    const parseDateFormat = (end_date: string) => {
      if (end_date && !end_date.includes(" ")) {
        const format = "YYYY-MM-DD HH:mm:ss"
        return moment.utc(end_date, format).endOf("day").format(format)
      }
      return end_date
    }

    promo_codes = promo_codes.filter(({ end_date }) => moment.utc(parseDateFormat(end_date)).isAfter(moment.utc()))
    this.promo_codes = this.functionService.sortByCreationDate(promo_codes, "end_date", true)
    if (this.promo_codes.length) {
      this.promo_code = this.promo_codes[0]
    }
  }

  changePromoCode() {
    const promo_codes = this.functionService.deepCopy<Array<PromotionalDiscounts>>(this.promo_codes)
    this.promo_codes = null
    setTimeout(() => this.sortPromoCodes(promo_codes), 1000)
  }

}
